var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2980_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 16.6668H7.16659L15.9166 7.91676C16.1355 7.69789 16.3091 7.43805 16.4275 7.15208C16.546 6.86612 16.6069 6.55962 16.6069 6.25009C16.6069 5.94056 16.546 5.63406 16.4275 5.3481C16.3091 5.06213 16.1355 4.80229 15.9166 4.58342C15.6977 4.36455 15.4379 4.19094 15.1519 4.07248C14.8659 3.95403 14.5594 3.89307 14.2499 3.89307C13.9404 3.89307 13.6339 3.95403 13.3479 4.07248C13.062 4.19094 12.8021 4.36455 12.5833 4.58342L3.83325 13.3334V16.6668Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.4165L15.0833 8.74984",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13.3335L16.3333 18.3335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 15.8335L16.3333 18.3335L18.8333 15.8335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2980_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.839a3d9ae52ebf69330f0978c6c1ff20.svg";
export { ForwardRef as ReactComponent };